import axios from 'axios';
import { GOBIZ_OAUTH_CALLBACK_URL } from '../constants';

import {
  PARTNER_GOBIZ_OAUTH_TOKEN,
  PARTNER_GOBIZ_TOKEN_BY_OUTLET_ID,
  PARTNER_GET_PARTNERS,
  PARTNER_GET_PARTNER_DETAIL,
  PARTNER_REGISTER_MERCHANT_CONSENT,
  PARTNER_UNREGISTER_MERCHANT_CONSENT,
} from './constant';

function getQueryString(data = {}) {
  return Object.entries(data)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(
          // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
          value
        )}`
    )
    .join('&');
}

export function exchangeAuthCode(authCode) {
  return axios
    .post(
      PARTNER_GOBIZ_OAUTH_TOKEN,
      {
        code: authCode,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        redirect_uri: `${GOBIZ_OAUTH_CALLBACK_URL}`,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        grant_type: 'authorization_code',
      },
      {
        transformRequest: getQueryString,
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    )
    .catch((error) => {
      if (error?.response?.data?.error_description) {
        return Promise.reject(new Error(error.response.data.error_description));
      }
      return Promise.reject(error);
    });
}

export function upsertPartnerToken(outletId, data) {
  return axios
    .put(PARTNER_GOBIZ_TOKEN_BY_OUTLET_ID(outletId), data, {
      withCredentials: true,
    })
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}

export function deletePartnerToken(outletId) {
  return axios
    .delete(PARTNER_GOBIZ_TOKEN_BY_OUTLET_ID(outletId), {
      withCredentials: true,
    })
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}

export function getPartners(params) {
  return axios
    .get(PARTNER_GET_PARTNERS, { params, withCredentials: true })
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}

export function getPartnerDetail(partnerId) {
  return axios
    .get(PARTNER_GET_PARTNER_DETAIL(partnerId), { withCredentials: true })
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}

export function registerMerchantConsent(partnerId) {
  return axios
    .post(
      PARTNER_REGISTER_MERCHANT_CONSENT(partnerId),
      {},
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}

export function unregisterMerchantConsent(partnerId) {
  return axios
    .post(
      PARTNER_UNREGISTER_MERCHANT_CONSENT(partnerId),
      {},
      {
        withCredentials: true,
      }
    )
    .catch((error) => {
      if (error?.response?.data?.error?.user_message) {
        return Promise.reject(
          new Error(error.response.data.error.user_message)
        );
      }
      return Promise.reject(error);
    });
}
